const prefix = 'monday';

export const LOCAL_THEME = `${prefix}-theme`;
